<template>
    <div class="auth">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "Auth"
}
</script>

<style scoped></style>